import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Inject, PLATFORM_ID, ViewChild, HostListener, OnChanges, SimpleChanges, AfterViewInit, Renderer2, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { slideInAnimation } from './animations';
import { MessageServiceService } from './_servizi/message-service.service';
import { AppoggioService } from './_servizi/appoggio.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    slideInAnimation
    // animation triggers go here
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'cantinewineiframe';

  constructor(
    translate: TranslateService,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private messageService: MessageServiceService,
    private router: Router,
    @Inject(PLATFORM_ID) private platform: any,
    private appoggioService: AppoggioService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private el: ElementRef
  ) {
    // translate.use(translate.getBrowserLang());


  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  get codiceForm() {
    return this.appoggioService.getCodiceForm();
  }

  get colori() {
    return this.appoggioService.getColoriIframe();
  }

  private touchMoveListener: () => void;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth > 850) {
      this.appoggioService.setFromMobile(false)
    } else {
      this.appoggioService.setFromMobile(true)
    }
  }

  ngOnDestroy(): void {
    this.removeTouchMoveListener();
  }

  ngOnInit() {
    this.addTouchMoveListener();

    if (window.innerWidth > 850) {
      this.appoggioService.setFromMobile(false)
    } else {
      this.appoggioService.setFromMobile(true)
    }
  }

  addTouchMoveListener() {
    const nativeElement = this.el.nativeElement;
    const listener = (event: TouchEvent) => {
      console.log('Moving touch...');
    };
    nativeElement.addEventListener('touchmove', listener, { passive: true });
    this.touchMoveListener = () => nativeElement.removeEventListener('touchmove', listener);
  }

  removeTouchMoveListener() {
    // Rimuove l'event listener quando il componente viene distrutto
    if (this.touchMoveListener) {
      this.touchMoveListener(); // Esegue la rimozione
    }
  }

  addGoogleFont(fontName) {
    if (fontName != null) {
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'stylesheet');
      this.renderer.setAttribute(link, 'href', `https://fonts.googleapis.com/css?family=${fontName.replace(' ', '+')}:regular,bold,italic`);
      this.renderer.appendChild(document.head, link);
    }
  }

  getStyleIframe() {


    this.addGoogleFont(this.colori && this.colori.font ? this.colori.font : null);

    document.documentElement.style.setProperty('--base-color', this.colori && this.colori.testo ? this.colori.testo : '#2d2d2d');
    document.documentElement.style.setProperty('--base-bgk', this.colori && this.colori.sfondo ? this.colori.sfondo : 'transparent');

    document.documentElement.style.setProperty('--items-border', this.colori && this.colori.testo ? this.colori.testo + '25' : '#2d2d2d25');
    document.documentElement.style.setProperty('--items-btn-bgk', this.colori && this.colori.sfondoBtnItems ? this.colori.sfondoBtnItems : '#2d2d2d');
    document.documentElement.style.setProperty('--items-btn-color', this.colori && this.colori.coloreBtnItems ? this.colori.coloreBtnItems : '#ffffff');
    document.documentElement.style.setProperty('--items-btn-bgk-hover', this.colori && this.colori.sfondoBtnItemsHover ? this.colori.sfondoBtnItemsHover : '#2d2d2d');
    document.documentElement.style.setProperty('--items-btn-color-hover', this.colori && this.colori.coloreBtnItemsHover ? this.colori.coloreBtnItemsHover : '#ffffff');

    document.documentElement.style.setProperty('--items-bgk', this.colori && this.colori.sfondoCardItems ? this.colori.sfondoCardItems : '#ffffff');

    document.documentElement.style.setProperty('--header-bgk', this.colori && this.colori.sfondoHeader ? this.colori.sfondoHeader : 'var(--green-bgk)');
    document.documentElement.style.setProperty('--header-color', this.colori && this.colori.coloreHeader ? this.colori.coloreHeader : 'var(--green-text)');

    document.documentElement.style.setProperty('--secondary-bgk', this.colori && this.colori.sfondoBtnSecondario ? this.colori.sfondoBtnSecondario : 'var(--lightgreen-text)');
    document.documentElement.style.setProperty('--primary-bgk', this.colori && this.colori.sfondoBtnPrimario ? this.colori.sfondoBtnPrimario : 'var(--red-text)');
    document.documentElement.style.setProperty('--secondary-color', this.colori && this.colori.coloreBtnSecondario ? this.colori.coloreBtnSecondario : '#fff');
    document.documentElement.style.setProperty('--primary-color', this.colori && this.colori.coloreBtnPrimario ? this.colori.coloreBtnPrimario : '#fff');

    document.documentElement.style.setProperty('--secondary-bgk-hover', this.colori && this.colori.sfondoBtnSecondarioHover ? this.colori.sfondoBtnSecondarioHover : 'var(--lightgreen-dark-text)');
    document.documentElement.style.setProperty('--primary-bgk-hover', this.colori && this.colori.sfondoBtnPrimarioHover ? this.colori.sfondoBtnPrimarioHover : 'var(--red-dark-text)');
    document.documentElement.style.setProperty('--secondary-color-hover', this.colori && this.colori.coloreBtnSecondarioHover ? this.colori.coloreBtnSecondarioHover : '#fff');
    document.documentElement.style.setProperty('--primary-color-hover', this.colori && this.colori.coloreBtnSecondarioHover ? this.colori.coloreBtnSecondarioHover : '#fff');


    document.documentElement.style.setProperty('--tipologie-bgk', this.colori && this.colori.sfondoBtnSecondario ? this.colori.sfondoBtnSecondario : '#e2e1e1');
    document.documentElement.style.setProperty('--tipologie-color', this.colori && this.colori.coloreBtnSecondario ? this.colori.coloreBtnSecondario : '#2d2d2d');
    document.documentElement.style.setProperty('--bold-color', this.colori && this.colori.coloreBold ? this.colori.coloreBold : '#2d2d2d');
    document.documentElement.style.setProperty('--bold-bgk', this.colori && this.colori.coloreBold ? this.colori.coloreBold + '40' : '#2d2d2d');

    // document.documentElement.style.setProperty('--font', this.colori && this.colori.coloreBold ? this.colori.coloreBold + '"Lobster", sans-serif' : '"Poppins", sans-serif');
    document.documentElement.style.setProperty('--font', this.colori && this.colori.font ? this.colori.font + ', sans-serif' : "'Poppins', sans-serif");

    return [];
  }
}
